import { PerformanceMetricMetadata } from '@/types/PerformanceMetricMetadata';
import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { FlatMetric } from './getSavedMetricsConfig';
import { getBasePath } from '@agyletime/vue-3-common/src/plugins/basePath';

export async function getAllMetricDefinitions(): Promise<PerformanceMetricMetadata[]> {
    const cachedColumnDefinitions = await fetchFromLambda<PerformanceMetricMetadata[]>('/performance-metrics/definitions/all',
        { headers: { 'X-Plvx-Beta': getBasePath().includes('_beta').toString() } }
    );
    return cachedColumnDefinitions;
}
export async function getEnabledMetricDefinitions(): Promise<FlatMetric[]> {
    const enabledColumnDefinitions = await fetchFromLambda<FlatMetric[]>('/performance-metrics/definitions',
        { headers: { 'X-Plvx-Beta': getBasePath().includes('_beta').toString() } }
    );
    return enabledColumnDefinitions;
}